module.exports = __webpack_public_path__ + "img/winerackdog42.6cede0e7.jpg";